export default __webpack_public_path__ + "static/media/guide-1.a5da4cec.png";